// extracted by mini-css-extract-plugin
export default {"ClientTab":"ClientWidget__ClientTab__BtUE6","ClientTabItem":"ClientWidget__ClientTabItem__qTPus","ClientId":"ClientWidget__ClientId__X0wfX"};